import React from 'react'
import { useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-regular-svg-icons'
import styles from './TrophyMemoryCardLoading.module.scss'

export const TrophyMemoryCardLoading: React.FC = () => {
  const { t } = useTranslation('trophy_memories')

  return (
    <section className={ styles.trophyMemoryCardLoading__container }>
      <div className={ styles.trophyMemoryCardLoading__imageWrapper }>
        <FontAwesomeIcon
          icon={ faSpinner }
          size="2x"
          className={ styles.trophyMemoryCardLoading__image }
        />
      </div>

      <div className={ styles.trophyMemoryCardLoading__data }>
        <p className={ styles.trophyMemoryCardLoading__title }>
          { t('loading_card_title') }
        </p>

        <p className={ styles.trophyMemoryCardLoading__date }>
        { t('loading_card_description') }
        </p>
      </div>
    </section>
  )
}
